import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const contractsReducer = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.CONTRACTS_SUCCESS:
            return Object.assign({}, state, action.response.entities && action.response.entities.contract)
        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Contracts.js
 **/